import zipcodes from 'zipcodes';

export const getCityStateFromZip = async (zipCode)=> {
 const zip = String(zipCode).trim().split('-')[0];
  // Ensure it's a 5-digit number
  if (!/^\d{5}$/.test(zip)) return null;
 const result = zipcodes.lookup(zip);
 return result ? { city: result.city, state: result.state } : null;
}
